
export default function (state={}, action) {

	switch (action.type) {

	case 'FETCH_SET_REQUEST':
		state[action.setId]=true
		return state


	case 'LOGOUT':
		return {}

	default:
		return state

	}
}